import { call, put, takeEvery } from "redux-saga/effects"
import { getCustomizeOrderForAdminError, getCustomizeOrderForAdminSuccess, updateCustomizeOrderForAdminError, updateCustomizeOrderForAdminSuccess } from "./actions"
import { AppConfiguration } from "config";
import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper";
import { GET_CUSTOMIZE_ORDER_FOR_ADMIN, UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN } from "./actionTypes";
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper";

function* onGetCustomizeOrderForAdmin(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_admin_user_customize_orders`,
      action?.payload,
      {
        Authorization: user.token,
      }
    )
    yield put(getCustomizeOrderForAdminSuccess(response))
  } catch (error) {
    yield put(getCustomizeOrderForAdminError(error))
  }
}

function* onUpdateCustomizeOrderForAdmin(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/update_admin_user_customize_orders/${action.payload.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateCustomizeOrderForAdminSuccess(response, action.payload.component))
  } catch (error) {
    yield put(updateCustomizeOrderForAdminError(error))
  }
}

function* CustomizeOrderForAdminSaga() {
  yield takeEvery(GET_CUSTOMIZE_ORDER_FOR_ADMIN, onGetCustomizeOrderForAdmin);
  yield takeEvery(UPDATE_CUSTOMIZE_ORDER_FOR_ADMIN, onUpdateCustomizeOrderForAdmin);
}

export default CustomizeOrderForAdminSaga;
